import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ApiClientService, Sms_potraznja } from '../../../services/api-client.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-mobilne-potraznje',
  templateUrl: './mobilne-potraznje.component.html',
  styleUrls: ['./mobilne-potraznje.component.scss']
})
export class MobilnePotraznjeComponent implements OnInit {
  constructor(
    private apiClient: ApiClientService,
    private cdRef: ChangeDetectorRef,
    private userService: UserService
  ) {
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
  }

  countries: any[] = [];
  selectedCountry: string = '';
  startDate: Date = new Date(new Date().toDateString());
  endDate: Date = new Date(new Date(new Date().toDateString()).setHours(23, 59, 59, 999));
  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#mobilnaPotraznjeGrid' };
  createMobilnaPotraznjaPopupVisible: boolean = false;
  editMobilnaPotraznjaPopupVisible: boolean = false;
  isUserModerator: boolean = false;
  selectedMobilnaPotraznja: Sms_potraznja;
  @ViewChild('mobilnaPotraznjeGrid', { static: false }) mobilnaPotraznjeGrid: DxDataGridComponent;

  ngOnInit() {
    this.initializeCountries();
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
  }

  initializeCountries() {
    this.countries = [
      { code: 'BiH', name: 'Bosna i Hercegovina' },
      { code: 'Srb', name: 'Srbija' },
      { code: 'Hrv', name: 'Hrvatska' },
      { code: 'Ino', name: 'Uvoz/Izvoz' }
      // Add other countries as needed when API endpoints are available
    ];
  }

  onStartDateChange(event: any) {
    this.startDate = event;
  }

  onEndDateChange(event: any) {
    console.log('End date changed:', event);
    this.endDate = event;
  }

  isFormValid(): boolean {
    return !!this.selectedCountry && !!this.startDate && !!this.endDate;
  }

  toLocalAsUTC(date: Date): Date {
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return newDate;
  }

  async loadData() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    var result: any[] = [];
    try {
      switch (this.selectedCountry) {
        case 'BiH':
          result = await this.apiClient.biHAll4(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          break;
        case 'Srb':
          result = await this.apiClient.srbAll4(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          break;
        case 'Hrv':
          result = await this.apiClient.hrvAll4(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          break;
        case 'Ino':
          result = await this.apiClient.inoAll4(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
          break;
        default:
          console.warn('No API endpoint for selected country:', this.selectedCountry);
          break;
      }

      this.gridData = result;

    } catch (error) {
      console.error('Error loading mobilna potražnja data:', error);
    } finally {
      this.loading = false;
    }
  }

  showCreateMobilnaPotraznja() {
    this.createMobilnaPotraznjaPopupVisible = true;
  }

  async onMobilnaPotraznjaCreated(e: any) {
    await this.loadData();
  }

  async onMobilnaPotraznjaEdited(e: any) {
    await this.loadData();
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const mobilnaPotraznja = e.row.data;

    try {
      await this.apiClient.smsPotraznjeDELETE(mobilnaPotraznja.id);
      await this.apiClient.refreshCache();

      const index = this.gridData.findIndex(item => item.id === mobilnaPotraznja.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting mobilna potražnja:', error);
    }
  }

  onEditClick(e: any) {
    this.selectedMobilnaPotraznja = e.row.data;
    this.cdRef.detectChanges();
    this.editMobilnaPotraznjaPopupVisible = true;
  }
}